import styled from "@emotion/styled";
import { Box, Button, Label, theme } from "Application";

interface Props {
    color?: string;
    backgroundColor?: string;
}

export const AttendanceField = styled(Box)`
    @media only screen and (max-width: 600px) {
        flex-wrap: wrap;
        justify-content: stretch;
    }
    & > div {
        @media only screen and (max-width: 600px) {
            width: 100%;
            max-width: 100% !important;
        }
    }
    .form-control {
        input[type="checkbox"]:before {
            box-shadow: inset 1em 1em #e6054e;
        }
    }
`;

export const TargetList = styled(Box)`
    & > div:nth-of-type(odd) {
        background: #fff;
    }
`;

export const FormField = styled(Box)`
    .placeholder {
        font: italic normal normal 12px/16px Open Sans;
        letter-spacing: 0px;
        color: #000000;
    }
`;

export const CreateBox = styled(Box)`
    & > div .isButtonDisable {
        cursor: default;
        color: #495057;
        background-color: #e9ecef;
    }
`;

export const MentorBox = styled(Box)`
    .editselect {
        display: flex;
    }
`;

export const ToolTipBox = styled(Box)`
    & > label > div > div {
        top: auto;
        bottom: calc(100% + 10px);
        font-size: 12px;
    }
`;

export const FlexBox = styled(Box)``;

export const FourCol = styled(Box)`
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 15px;
    @media only screen and (max-width: 1200px) {
        grid-template-columns: 1fr 1fr;
    }
    @media only screen and (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const DetailsList = styled(Box)`
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 15px;
    @media only screen and (max-width: 1200px) {
        grid-template-columns: 1fr 1fr;
    }
    @media only screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 15px;
    }
`;

export const TableFilter = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr 3fr 1fr;
    column-gap: 30px;
    padding-bottom: 20px;
    border-bottom: 1px dashed ${theme.palette.tableHeader.main};

    @media only screen and (max-width: 1440px) {
        grid-template-columns: 1.5fr 1.5fr 1.5fr 2fr 2fr 1fr;
    }
    @media only screen and (max-width: 1200px) {
        grid-template-columns: 2fr 2fr 2fr;
    }
    @media only screen and (max-width: 600px) {
        grid-template-columns: 2fr;
        gap: 20px !important;
    }
`;

export const TargetCheckbox = styled(Box)`
    input[type="checkbox"] {
        height: 30px;
        width: 30px;
        &::before {
            height: 16px;
            width: 18px;
            box-shadow: inset 1em 1em #bd9e17;
        }
    }
`;

export const TableList = styled(Box)``;

export const TableBox = styled(Box)<Props>`
    display: grid;
    grid-template-columns: 280px auto;
    @media only screen and (max-width: 767px) {
        grid-template-columns: 60px auto;
    }
    &:nth-of-type(2n) {
        background: #f9f9f9;
    }
    & > div:first-child {
        height: 100%;
        display: flex;
        & > label {
            padding: 0 15px;
            display: grid;
            grid-template-columns: 45px auto;
            gap: 0;
        }
    }
    input[type="checkbox"] {
        height: 30px;
        width: 30px;
        &::before {
            height: 16px;
            width: 18px;
            box-shadow: inset 1em 1em #bd9e17;
        }
    }
    label {
        font: normal normal bold 12px/16px Open Sans;
        letter-spacing: -0.12px;
    }
    .check-label {
        display: flex;
        align-items: center;
        border-left: 1px solid #dcdcdc;
        height: 100%;
        padding-left: 15px;
        @media only screen and (max-width: 767px) {
            display: none !important;
        }
        label {
            color: ${(p) => p.color};
        }
    }
    & > div:last-child {
        padding: 20px 10px;
        display: flex;
        justify-content: center;
        border-left: 1px solid #dcdcdc;
        flex-direction: column;
        gap: 2px;
        label {
            font: normal normal bold 12px/16px Open Sans;
            letter-spacing: -0.12px;
            &:first-child {
                display: none;
                @media only screen and (max-width: 767px) {
                    display: block;
                }
            }
        }
        & > label:last-child {
            font: normal normal normal 12px/16px Open Sans;
            color: #000000;
        }
    }
`;

export const SelectBox = styled(Box)<Props>`
    max-width: 130px;
    .editselect {
        & > div:first-child {
            background: white;
        }
    }
    .editselect__control {
        background: ${(p) => p.backgroundColor ?? "transparent"};
    }
    .editselect__placeholder,
    .editselect__single-value {
        color: #fff;
        font: normal normal bold 12px/18px Open Sans;
        letter-spacing: 0px;
    }
`;

export const StatusBox = styled(Box)<{ hasId: boolean }>`
    font: normal normal bold 12px/18px Open Sans;
    letter-spacing: 0px;
    text-transform: uppercase;
    background: ${(props) => (props.hasId ? "#11A696" : "#C15DB0")};
    text-align: center;
    color: #fff;
    height: 30px;
    width: 140px;
    padding: 6px 25px;
`;

export const Container = styled.div`
    background-color: white;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* Reserve space for the FixedActionButtons footer (70px) so the scroll area ends above it. */
    padding-bottom: 70px;
`;

export const Body = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    row-gap: 30px;
    padding: 30px 30px 30px 30px;
    @media screen and (max-width: 767px) {
        padding: 30px 10px 30px 10px;
    }
`;

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 15px;
`;

export const TitleLabel = styled(Label)`
    font: normal normal bold 18px/24px Open Sans;
    letter-spacing: 0px;
    color: #000000;
`;

export const EmptyDocumentsContainer = styled.div`
    padding: 20px 0px;
`;

export const AddDocLink = styled(Label)`
    text-decoration: underline;
    color: #2d91ff;
    display: inline-block;
`;

export const UploadButton = styled(Button)`
    border-radius: 5px;
`;

export const DocumentsTableWrapper = styled.div`
    overflow: auto;
    .mainTable {
        & > div {
            &:first-child {
                background: #f3f3f3;
                margin-bottom: 15px;
                & > div {
                    grid-template-columns: 9fr 3fr 2fr 1fr !important;
                    & > div:not(:last-child) {
                        border-right: 1px solid #fff;
                    }
                }
            }
            & > div {
                grid-template-columns: 9fr 3fr 2fr 1fr !important;
                &:nth-of-type(even) {
                    background: #f9f9f9;
                }
                & > div {
                    width: 100%;
                    box-sizing: border-box;
                    &:last-child {
                        border-right: none;
                    }
                }
            }
        }
        .justifyCenter {
            > div {
                justify-content: center;
            }
        }
        #lastAction {
            justify-content: flex-end;
        }
    }
`;
